import { memo } from 'react';

import { HookForm, Text } from '@dec/shared';
import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import env from 'env';
import { Card, Col, Row } from 'react-bootstrap';
import { Lock } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import validations from '../../components/recoveryRequest.validations';
import {
  type RecoveryRequesProps,
  type RecoveryRequestState
} from '../../models/recoveryRequest.model';

import { useRecoveryRequest } from './useRecoveryRequest';

// eslint-disable-next-line react/display-name
export const RecoveryRequest = memo((props: RecoveryRequesProps) => {
  const { t } = useTranslation();
  const { loading, submitForm } = useRecoveryRequest();

  const onSubmit = (values: RecoveryRequestState) => {
    submitForm(values.userName ?? '');
  };

  const cancel = () => {
    const values = env as any;
    window.location.href = values[props.redirectKey] as string;
  };

  return (
    <div className="container h-90">
      <div className="row align-items-center h-90">
        <div className="col-12 col-md-6 col-lg-5 mx-auto">
          <Card className="p-2">
            <Card.Body>
              <Row className="mb-4">
                <Col>
                  <div className="ms-auto me-auto">
                    <Lock size="80" />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <strong>{t('security-login.label.forgotPassword')}</strong>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col>{t('security-login.label.forgotPasswordInstructions')}</Col>
              </Row>
              <HookForm onSubmit={onSubmit} validations={validations}>
                <Row>
                  <Col>
                    <Text label={t('security-password-recovery.label.userName')} name="userName" />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col>
                    <Button
                      action={ButtonAction.send}
                      variant="primary"
                      type={'submit'}
                      disabled={loading}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <div className="separador mt-3">
                      <span>{t('security-login.label.loginAlternative')}</span>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-center mt-2">
                      <Link to="#" onClick={cancel}>
                        {t('security-password-recovery.label.returnLogin')}
                      </Link>
                    </div>
                  </Col>
                </Row>
              </HookForm>
            </Card.Body>
          </Card>
          <Card className="mt-3">
            <Card.Body>
              <span className="me-2">{t('security-login.label.notRegistered')}</span>
              <Link to="/public/taxpayer-request">{t('security-login.label.signup')}</Link>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
});
